import * as React from 'react'
import { countUp } from 'src/modules/Dashboard/Global/components/CountUp'
import { AlertsService } from 'src/share/services/alerts';

const initialAlertsByStatus = {
  activeAlerts: 0,
  sentAlerts: 0,
  stoppedAlerts: 0,
  warningAlerts: 0,
  errorAlerts: 0,
  expiredAlerts: 0
}

const AlertControlStats = () => {
  const [alertsByStatus, setAlertsByStatus] = React.useState<any>(initialAlertsByStatus);
  React.useEffect(() => {
    fetchNumbersByStatus();
  }, [])
  async function fetchNumbersByStatus(): Promise<void> {
    const { results } = await AlertsService.numbersByStatus();
    setAlertsByStatus({ ...results });
  }
  return (
    <div className="alert-control-center__status-numbers">
        <div className="status-numbers__status">
          <div className="status-text"><span className="circle bg-green" /> Active</div>
          <span>{countUp(alertsByStatus.activeAlerts)}</span>
        </div>
        <div className="status-numbers__status">
          <div className="status-text"><span className="circle bg-blue" /> Sent</div>
          <span>{countUp(alertsByStatus.sentAlerts)}</span>
        </div>
        <div className="status-numbers__status">
          <div className="status-text"><span className="circle bg-yellow" /> Stopped</div>
          <span>{countUp(alertsByStatus.stoppedAlerts)}</span>
        </div>
        <div className="status-numbers__status">
          <div className="status-text"><span className="circle bg-orange" /> Warning</div>
          <span>{countUp(alertsByStatus.warningAlerts)}</span>
        </div>
        <div className="status-numbers__status">
          <div className="status-text"><span className="circle bg-red" /> Error</div>
          <span>{countUp(alertsByStatus.errorAlerts)}</span>
        </div>
        <div className="status-numbers__status">
          <div className="status-text"><span className="circle bg-gray" /> Expired</div>
          <span>{countUp(alertsByStatus.expiredAlerts)}</span>
        </div>
      </div>
  )
};

export default AlertControlStats
